import type { Country } from '@packages/domain/models/country';
import { API_URL_V3 } from 'constants/config';
import { fetchJson } from 'utils/fetchJson/fetchJson';

export const countries = {
  fetch: ({ locale = 'EN' }) => {
    const path = `${API_URL_V3}/countries?locale=${locale}`;

    return fetchJson<Country[]>(path);
  },
};
